<template>
  <div :class="['font-selector', { 'font-selector--disabled': disabled }]">
    <div
      v-for="({ name, icon }, index) in fonts"
      :key="index"
      :class="['font-selector__item', { 'font-selector__item--selected': selectedFont === name }]"
      @click="emits('fontSelected', name)"
    >
      <component class="font-selector__icon" :is="icon"></component>
    </div>
  </div>
</template>
<script setup lang="ts">
import { FontData } from '@/static/fonts'

const props = defineProps<{
  fonts: FontData[],
  selectedFont: string | null,
  disabled: boolean
}>()

const emits = defineEmits<{
  (event: 'fontSelected', fontName: string): void
}>()
</script>
<style lang="scss">
.font-selector {
  $root: #{&};
  display: grid;
  grid-template-columns: 143px 143px;
  grid-auto-rows: 40px;
  gap: 8px;

  &__item {
    background-color: $button-grey;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2px;
    cursor: pointer;
    transition: background-color 150ms $animationCurve;

    &:hover {
      background-color: $grey-80;
    }

    &--selected {
      &, &:hover {
        background-color: $button-grey;
        border: 2px solid $white;
      }
    }
  }

  &--disabled {
    pointer-events: none;

    #{$root}__icon * {
      fill: $grey-80;
    }
  }
}
</style>